import firebase from 'firebase';
import { firebaseApp } from '../../data/config';

export const twitterProvider = new firebase.auth.TwitterAuthProvider();

const twitterAuth = async (onSuccess, onFail) => {
  try {
    firebaseApp
      .auth()
      .signInWithPopup(twitterProvider)
      .then((result) => {
        onSuccess(onSuccess(result.user));
      });
  } catch (error) {
    onFail(error);
  }
};

export default twitterAuth;
